module.exports = __webpack_public_path__ + "img/22.a525a74b.png";